import { useMutation } from '@apollo/client';
import { UPDATE_COMPANY_LOGO } from '@general/graphql/company.graph';

const useCompanyLogo = () => {
    const [updateCompanyLogoMutation] = useMutation(UPDATE_COMPANY_LOGO);

    const updateCompanyLogo = async () => {
        const {
            data: {
                updateCompanyLogo: { ...imageData },
            },
        } = await updateCompanyLogoMutation();

        return imageData;
    };

    return { updateCompanyLogo };
};

export default useCompanyLogo;
